export let courses = [
  {
    name: 'MATH PATHWAYS OVERVIEW',
    department: 'Math',
    grades: [9, 10, 11, 12],
    description: '',
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
  {
    name: 'Math 9',
    department: 'Math',
    grades: [9],
    description: 'This course is a continuation of Math 8 with an emphasis on expanding the algebraic concepts introduced in middle school.  Major topics include polynomials, equation solving, congruence and similarity, exponents, financial literacy, and problem-solving.',
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
  {
    name: 'Foundations of Math & Pre-Calculus 10',
    department: 'Math',
    grades: [10],
    description: `Interested in continuing your education in a college, technical institute or university?  Foundations of Math and Pre-Calculus 10 is the course for you.  This course has a heavy focus on algebraic reasoning but also covers trigonometry, measurement, probability and financial literacy.
    <br /><br />
    Recommended level of entry is 67% (C+) in Math 9.`,
    prerequisites: [{
      req: 'Math 9'
    }],
    video: ''
  },
  {
    name: 'Workplace Math 10',
    department: 'Math',
    grades: [10],
    description: 'If you plan on going directly into the workforce or entering an apprenticeship program, then Workplace Math 10 is likely the math course for you.  Topics covered in this course include personal finance, area, volume and mass, metric and imperial measurements, geometry, and trigonometry.  The Workplace Math 11 and Apprenticeship Math 12 courses follow Workplace Math 10.  There is no pre-requisite for Workplace Math 10.  Make sure to check the required math courses if you are planning to learn a trade, as some will require a higher level of math.',
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
  {
    name: 'Computer Science 11',
    department: 'Math',
    grades: [10, 11, 12],
    description: 'Ever wondered how computer programs (apps) are written? A basic understanding of coding will help you succeed in countless different career paths. You should take this course if you are thinking of entering a Computer Science or Software Development program at university or college, or if you simply want to learn how to code for fun! You will build your skills as a programmer using Processing, a popular and beginner-friendly language that specializes in graphics. This course is open to students in grades 10 through 12, with decent math skills.',
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
  {
    name: 'Foundations of Math 11',
    department: 'Math',
    grades: [11, 12],
    description: `Foundations of Math 11 is an academic math course.  It is designed for students who plan to attend college or university to study social sciences, humanities, or the arts.  Topics covered in this course include geometry, trigonometry, statistical reasoning, loans and mortgages, and algebra.
    <br /><br />
    Recommended level of entry is 67% (C+) in Foundations of Math and Pre-Calculus 10`,
    prerequisites: [{
      req: 'Foundations & Pre-Calculus 10'
    }],
    video: ''
  },
  {
    name: 'Pre-Calculus 11',
    department: 'Math',
    grades: [11, 12],
    description: `Pre-Calculus 11 is an academic math course with a big emphasis on algebra.  The course was created for students planning to enroll in a technical institute or university to study science, math, engineering, pre-med or economics.  Topics covered in this course include trigonometry, loans and mortgages, quadratic functions and equations, rational expressions and equations, and radical expressions.
    <br /><br />
    Recommended level of entry is 67% (C+) in Foundations of Math and Pre-Calculus 10.`,
    prerequisites: [{
      req: 'Foundations & Pre-Calculus 10'
    }],
    video: ''
  },
  {
    name: 'Workplace Math 11',
    department: 'Math',
    grades: [11, 12],
    description: 'Workplace Math 11 is for students planning on entering most apprenticeship programs or moving directly into the workplace upon completion of high school.  Its focus is on delivering practical Math skills needed for everyday life.  Topics covered in this course include measurement, graphing, trigonometry, and personal finance.',
    prerequisites: [{
      req: 'any Math 10'
    }],
    video: ''
  },
  {
    name: 'Calculus 12',
    department: 'Math',
    grades: [12],
    description: `Students heading for post-secondary science, math, engineering, pre-med or economics programs are strongly encouraged to take this course.  Universities report a higher success rate in first-year Calculus for those students who have previously taken Calculus 12.  Students may take this course during the same year they take Pre-Calculus 12.
    <br /><br />
    Calculus provides us with mathematical tools to analyze continuous change.  Students will learn about the concept of the limit and how it helped lead to the development of two new math operations: differentiation and integration.  Students will learn various differentiation and integration techniques, and will explore the interpretation and useful application of derivatives and integrals.`,
    prerequisites: [{
      req: 'Pre-Calculus 12'
    }],
    video: ''
  },
  {
    name: 'Foundations of Math 12',
    department: 'Math',
    grades: [12],
    description: 'Foundations of Math 12 is a continuation of the Foundations of Math 11 course.  The course is comprised of an interesting mixture of number theory topics and algebraic functions.  Topics include set theory, combinations and permutations, probability, graphing polynomial, exponential, logarithmic and sinusoidal functions.',
    prerequisites: [{
      req: 'Foundations of Math 11'
    }],
    video: ''
  },
  {
    name: 'Pre-Calculus 12',
    department: 'Math',
    grades: [12],
    description: `This course will prepare students for the study of Calculus in post-secondary science, math, engineering, pre-med or economics programs. Students will learn about various families of functions, including exponential, logarithmic, trigonometric and polynomial.  They will explore function transformations, techniques for graphing by hand and with technology, and how these functions can be applied to solve useful problems.  Reasoning, modelling and problem solving will be emphasized throughout.
    <br /><br />
    Recommended level of entry is 67% (C+) in Pre-Calculus 11.`,
    prerequisites: [{
      req: 'Pre-Calculus 11'
    }],
    video: ''
  },
  {
    name: 'SCIENCE OVERVIEW',
    department: 'Science',
    grades: [9, 10, 11, 12],
    description: '',
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
  {
    name: 'Science 9',
    department: 'Science',
    grades: [9],
    description: 'These courses enable students to develop basic concepts in chemistry, biology, physics and environmental sustainability; to develop skills in the process of scientific inquiry; and to relate science to technology, society and the environment. Students work with an emphasis on the Nature of Science (Scientific Skills and Lab Safety). The students will expand their knowledge in these key areas: Chemistry (Atoms, Elements and Compounds), Environmental Sustainability (matter cycles), Biology (Reproduction), Physics (Characteristics of Electricity) and Aboriginal Ways of Knowing. Students may also have the opportunity to take part in our Greenhouse Project.',
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
  {
    name: 'Science 10',
    department: 'Science',
    grades: [10],
    description: 'Science 10 builds off of the concepts covered in Science 9. This course is intended to further student engagement with key scientific concepts and continue to build critical thinking skills. Topics covered include lab safety and the scientific method; chemicals and chemical reactions; energy and radioactivity; DNA and genetics; and astronomy and the Big Bang theory. As with Science 9, we will look at Science 10 from a First Peoples Perspective too.',
    prerequisites: [{
      req: 'Science 9'
    }],
    video: 'https://youtu.be/bsVGw6mPPPA'
  },
  {
    name: 'Chemistry 11',
    department: 'Science',
    grades: [11, 12],
    description: 'Chemistry 11 starts with lab safety and communicating science effectively at first, then includes the study of properties and classification of matter, atomic structure, organization of the periodic table, chemical bonding and gases. It introduces and applies the mole concept, chemical reactions and stoichiometry, and the chemistry of solutions (as well as an optional unit of organic chemistry). Scientific literacy is enhanced and relationships between First Peoples perspectives of Chemistry will continue to be developed. The aim is to extend students’ knowledge of the real-world applications of senior Chemistry as preparation for careers and Chemistry 12.',
    prerequisites: [{
        req: 'Science 10'
      },
      {
        req: 'Foundations & Pre-Calculus 10'
      }
    ],
    video: 'https://youtu.be/bsVGw6mPPPA'
  },
  {
    name: 'Life Sciences 11',
    department: 'Science',
    grades: [11, 12],
    description: 'Life Sciences 11 is a study of the living world and enables students to develop basic concepts in biology: evolution, microbiology (study of microbes), taxonomy (classification), characteristics of living things, cells, viruses, reproduction, genetics, and the six kingdoms. Throughout the course, students will develop skills in the process of scientific inquiry; and relate science to technology, society and the environment. In the first half of the course, students will expand their knowledge in these key areas: characteristics of living things, cells, evolution, taxonomy, viruses, and microbiology (study of microbes).  In the second half of the course, students will expand their knowledge in these key areas: genetics, Six kingdoms: Monera (Archaebacteria and Eubacteria), Protista, Fungi, Plantae, and Animalia. Aboriginal Ways of Knowing in this section include First Peoples’ understanding of animal body plans.',
    prerequisites: [{
      req: 'Science 10'
    }],
    video: 'https://youtu.be/bsVGw6mPPPA'
  },
  {
    name: 'Physics 11',
    department: 'Science',
    grades: [11, 12],
    description: `Physics 11 is an introductory course that focuses on the principles and theories of physics, encourages the investigation of physical relationships, and illustrates the relationship between theory and application.  Topics include Skills, Methods, and Nature of Physics, 1D kinematics – displacement, velocity, acceleration, and projectiles, 1D dynamics – study of forces and Newton’s laws, 1D momentum, Work and Energy, Electric Circuits, Wave Motion and Geometrical Optics, and Einstein’s Theory of Relativity.
    <br /><br />
    Recommended level of entry is 67% (C+) in both Science 10 and Foundations of Math & Pre-Calculus 10.`,
    prerequisites: [{
        req: 'Science 10'
      },
      {
        req: 'Foundations & Pre-Calculus 10'
      }
    ],
    video: 'https://youtu.be/bsVGw6mPPPA'
  },
  {
    name: 'Science for Citizens 11',
    department: 'Science',
    grades: [11, 12],
    description: 'This course explores how science guides our decisions and impacts our daily lives.  We will learn how science impacts places of employment and allows us to respond and adapt to local and global changes.  Topics may include epidemiology, disease transmission, personal health and safety, safety in the workplace, practical applications of science in different workplaces (forensics, fluid dynamics) and every day decisions (vaccinations, role of public health), climate change, and natural resources. Decision making, research, reading, discussion and critical thinking skills will be stressed. This course is designed for a wide range of student abilities and provides a non-academic science credit for high school graduation.',
    prerequisites: [{
      req: 'Science 10'
    }],
    video: 'https://youtu.be/bsVGw6mPPPA'
  },
  {
    name: 'Anatomy & Physiology 12',
    department: 'Science',
    grades: [12],
    description: `Anatomy and Physiology 12 focuses on human biology. The units covered enable students to develop basic concepts in biology including homeostasis, DNA and cells.  Also, students will understand the organization of the body systems including, digestion, cardiovascular, lymphatic, respiratory, urinary (excretory), reproductive, and nervous.
  <br /><br />
  In the first half of the course students will expand their knowledge in these key areas: homeostasis; including biological molecules and cellular compounds, dehydration and synthesis reactions, enzymes and metabolic pathways, feedback loops, cell processes.
  <br /><br />
  In the second half of the course students will expand their knowledge in these key areas: plant and animal cells, and organs, digestive, respiratory, nervous, excretory, reproductive systems of humans, and dissection of a fetal pig, animal heart and kidney.
  `,
    prerequisites: [{
      req: 'Life Sciences 11'
    }],
    video: 'https://youtu.be/bsVGw6mPPPA'
  },
  {
    name: 'Chemistry 12',
    department: 'Science',
    grades: [12],
    description: 'Ever wondered how scientists can predict whether or not a reaction will happen and if so how far and how fast?! Ever wondered what exactly determines whether something is an acid or a base? How does equilibrium apply to the acid-base chemistry in your body? What are oxidation-reduction reactions? How are they used in real life situations? The answers are all here! Chemistry 12 focuses on rates and mechanisms of reactions, dynamic chemical equilibrium systems, oxidation-reduction, and acid-base equilibria in preparation for Chemistry at the undergraduate level. It draws on previously acquired lab skills and extends them further.  To complete this course, solid mathematical problem-solving skills are required. As in all senior courses, an extension of the scientific method and parallels between Western and First Peoples Perspectives will be drawn.',
    prerequisites: [{
      req: 'Chemistry 11'
    }],
    video: 'https://youtu.be/bsVGw6mPPPA'
  },
    {
    name: 'Physics 12',
    department: 'Science',
    grades: [12],
    description: `Physics 12 provides opportunities for students to understand and apply the principles and concepts of Physics to practical situations while building problem solving skills.  Topics include vectors, 2D kinematics-displacement, velocity, acceleration and projectiles in 2D.  Students also learn about 2D dynamics, equilibrium (force and torque), 2D momentum and energy, circular motion and gravitation, electrostatics – electric force, electric field, electric potential, and electromagnetism – magnetic forces and induction.
    <br /><br />
    Recommended level of entry is 67% (C+) in both Physics 11 and Pre-Calculus 11.`,
    prerequisites: [{
        req: 'Physics 11'
      },
      {
        req: 'Pre-Calculus 11'
      }
    ],
    video: 'https://youtu.be/bsVGw6mPPPA'
  },
  {
    name: 'Specialized Science 12',
    department: 'Science',
    grades: [12],
    description: `The city of Prince Rupert is located on one of the most unique and diverse physical environments in the world. In Specialized Science 12 (Fisheries), students will have the opportunity to learn about all about the unique physiological features of the coastal environment as well as the biological, ecological and behavioural roles of some of this region's important local species and natural resources. This class will also focus on and give access to skills utilized in many local careers in fisheries science, environmental stewardship, ocean systems monitoring, and outdoor recreation.
  `,
    prerequisites: [{
      req: 'Science 11'
    }],
    video: 'https://youtu.be/3bvLgikp3M8'
  },
  {
    name: 'English 9',
    department: 'English',
    grades: [9],
    description: 'Students continue to build on the reading and writing strategies developed through Language Arts.  A variety of both fiction and non-fiction are used.  Students have more responsibility for interpreting and responding to what they read; materials become increasingly complex.  Formal writing situations, especially the essay, become the norm.  Students should be able to compose full sentences and paragraphs and to proofread for awkward writing.  The careful use of language for effect and the use of more sophisticated vocabulary is a primary goal.',
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
  {
    name: 'English 10: Literary Studies & Composition',
    department: 'English',
    grades: [10],
    description: 'This course is designed to teach students about various genres of literature in the forms of poetry, short stories, novels, drama, graphic novels, children’s literature, Canadian literature, First Peoples’ texts, thematic studies and/or specific author studies.   Students will explore a range of literary topics to increase their literacy skills, enhance their understanding of the English language, expand their development as educated global citizens, develop balance and broaden their understanding of themselves and the world and develop higher-level thinking and learning skills.   This will include the development of written communication, in particular essay writing. Students will read and study essays/compositions by other writers and consider a variety of styles as models for the development of their writing in terms of planning, drafting, editing, and writing for specific audiences and purposes.  Elements of creative writing such as slam poetry, oratory, rap, drama, song, graphic novels, and non-fiction may also be explored.  As well, elements of new media and digital literacy may be explored.',
    prerequisites: [{
      req: 'English 9'
    }],
    video: ''
  },
  {
    name: 'English First Peoples 10: Literary Studies & Writing',
    department: 'English',
    grades: [10],
    description: 'This course is designed for students who are interested in exploring First Peoples’ literature in a variety of contexts, genres, and media. This area of choice provides students with opportunities to explore personal and cultural identities, histories, stories, and connections to land/place. This course is grounded in the understanding of how texts are historically and culturally constructed. Students will work individually and collaboratively to broaden their understanding of themselves and the world.   One focus of the course is on a thematic study of First Peoples literature, locally developed First Peoples’ texts, Specific First Nations, Métis, or Inuit author study, First Peoples’ children’s literature, and storytelling in a First Peoples’ context.  In addition, students will develop their writing skills and create coherent, purposeful, and engaging compositions, essays and various forms of creative writing in an exploration of First Peoples themes.  Lastly, elements of digital literacy and new media may be explored to create original pieces and express themselves creatively in a variety of genres.  This will involve the study of both written and oral forms of communication.  This will involve a focus on media, journalism and publishing related to First Peoples themes.',
    prerequisites: [{
      req: 'English 9'
    }],
    video: ''
  },
    {
    name: 'English 11: Literary Studies',
    department: 'English',
    grades: [11],
    description: 'This course allows students to delve deeply into literature. Possible areas of focus will include genre-specific studies including poetry, short stories, novels, drama, graphic novels, children’s literature and others.  Students will work on literacy skills, English Language Arts core competencies, and developing higher-level thinking and learning skills to balance and broaden their understanding of themselves and the world, as well as to expand their development as educated global citizens.  In addition, students will work on various elements of written communication through practice and revision.  Areas of study include narrative, expository, descriptive, persuasive and opinion essays, as well as writing for specific audiences/disciplines, proper citation and vetting sources of information for quality and reliability.  Students may also explore various elements of creative writing and new media (digital literacy).',
    prerequisites: [{
      req: 'English 10'
    }],
    video: ''
  },
  {
    name: 'English First Peoples 11: Literary Studies & Writing',
    department: 'English',
    grades: [11],
    description: 'This course is designed for students who are interested in studying First Peoples literature and using writing for self-expression and communication in a variety of contexts. Students delve deeply into First Peoples oral and written literature in a range of media to explore various themes, authors, and topics. This provides a foundation for them to think critically and creatively as they continue to explore, extend, and strengthen their own writing. Within a supportive community, students work individually and collaboratively to explore oral and written literature and create powerful, purposeful compositions, various types of essays and creative writing. Through their work in the course, they will deepen their understanding of themselves and the world, and expand their understanding of what it means to be educated Canadian and global citizens.  Possible areas of study include community focused text, personal and cultural identity, exploration of First Nations themes, performance art, academic, technical and professional composition and intersections between First Peoples themes and other social justice issues.  Students may also explore elements of new media and digital literacy related to First Peoples themes.',
    prerequisites: [{
      req: 'any English 10'
    }],
    video: ''
  },
  {
    name: 'English First Peoples 12',
    department: 'English',
    grades: [12],
    description: 'EFP 12 builds upon and extends students’ previous learning experiences in ELA and EFP 10 and 11 courses. The course is grounded in the First Peoples Principles of Learning. It is designed for all students, Aboriginal and non-Aboriginal, who are interested in delving deeply into First Peoples oral and written literature and visual texts in a range of media. The course focuses on the experiences, values, beliefs, and lived realities of First Peoples as evidenced in various forms of text, including oral story, poetry, song, performance, film, and prose. A key feature of the course is its focus on authentic First Peoples voices (i.e., historical or contemporary texts created by or with First Peoples). In EFP 12, all students will examine texts grounded in a diversity of First Peoples cultures, including local First Nations or Métis communities.  They will extend their capacity to communicate effectively in a variety of contexts and think critically and creatively about the uses of language to deepen their understanding of themselves and others in a changing world.  It will also help them gain insight into the diverse factors that have shaped and continue to shape their own identities, as well as appreciate the importance of self-representation through authentic First Peoples text.  The course will contribute to Reconciliation by building a greater understanding of the knowledge and perspectives of First Peoples and expanding their understandings of what it means to be educated Canadian and global citizens.',
    prerequisites: [{
      req: 'any English 11'
    }],
    video: ''
  },
  {
    name: 'Student Leadership 9-12',
    department: 'Business',
    grades: [9, 10, 11, 12],
    description: 'Are you interested in making CHSS the best it can be? Then this course is for you!  This is Student Council with course credit.  Students will meet once a week at lunchtime as a full class and will attend other small committee meetings at various times including lunch or after school as needed. The class will work in many initiatives to improve CHSS including the organizing and administration of events such as holiday activities, school improvement, staff appreciation, Student Voice Forum, food drive, civic pride, fundraising, and spirit activities. The class will cover skills in time management, public speaking, meeting management, event organizing, public relations, reflection and evaluation.  This course grants 2 credits toward graduation rather than the usual 4.',
    prerequisites: [{
      req: ''
    }],
    video: '',
    tag: 'ott'
  },
  {
    name: 'Entrepreneurship and Marketing 10 ',
    department: 'Business',
    grades: [10, 11, 12],
    description: 'Not sure what the business world is about? Curious? Then take this introductory course. In it, you will get to sample the various industries in business by creating your own restaurant from; floor plans and menus, to staffing and management. Other topics explored in this course will be generated from student interest, whether it is in operating big corporations, to running a local business, to politics, or how to make food in commercials look appetizing (Psst…ice cream advertisements actually use mashed potatoes, and Santa Claus is only red and white because of Coca Cola).',
    prerequisites: [{
      req: ''
    }],
    video: 'https://youtu.be/WsTpxiai6n8'
  },
    {
    name: 'Accounting 11',
    department: 'Business',
    grades: [10, 11, 12],
    description: 'Give yourself an advantage! Learn accounting concepts and skills that will form a sound basis for financial record keeping. The information and skills learned in this course are fundamental to all aspects of life, and will give you an advantage if you plan to pursue business after high school or plan to work with Excel. Not to mention that becoming a certified professional accountant gives you access to travel, a high salary, and diverse career options.',
    prerequisites: [{
      req: 'Math 9'
    }],
    video: 'https://youtu.be/WFx2r-KV5L4'
  },
  {
    name: 'Marketing and Promotion 11',
    department: 'Business',
    grades: [10, 11, 12],
    description: 'T.V. commercials, social media, YouTube Ads, and the stock market are just a few topics covered in this course. In it, you will explore how to convince consumers to buy your product via creative and impactful marketing techniques. Innovate, invent, and sell!',
    prerequisites: [{
      req: ''
    }],
    video: 'https://youtu.be/jcrabjKtQNA'
  },
    {
    name: 'Accounting 12 ',
    department: 'Business',
    grades: [11, 12],
    description: 'Continue your accounting studies with the focus of merchandise accounting. In this course, you focus on inventory, payroll, and an alternative journal/ledger system. Take this course if you wish to further your development of Sage Simply Accounting and Microsoft Excel Skills.',
    prerequisites: [{
      req: 'Accounting 11'
    }],
    video: 'https://youtu.be/WFx2r-KV5L4'
  },
  {
    name: 'Foods 9',
    department: 'Home Economics',
    grades: [9],
    description: 'Learn to cook for yourself, your friends and your family! Students will learn the basics of simple food preparation and nutrition. Topics covered include baking (muffins, biscuits, cookies), and simple meals (chow mein, pasta). There is a strong emphasis on group collaboration and cooperation in this course.',
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
  {
    name: 'Food Studies 10',
    department: 'Home Economics',
    grades: [10],
    description: 'This course allows students to learn new techniques and prepare a variety of dishes while trying new foods. Students will develop new skills that will allow them to safely prepare food for themselves, friends and family. Skills acquired in this class also transfer well to the workplace. Recipe selection is based on seasonal ability and class input. Design challenges and cooking competitions enable students to put their new cooking skills to work. There is a strong emphasis on group collaboration and cooperation in this course.',
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
  {
    name: 'Culinary Arts 11/12',
    department: 'Home Economics',
    grades: [11, 12],
    description: 'This is a course for the cooking enthusiast who is eager to become skilled in international and gourmet cuisine. This hands-on applied skills course provides an advanced study of food preparation and builds on skills learned in Foods 10. Learn to budget, shop and cook healthy meals for yourself and family members. Explore advanced techniques such as preservation, meat processing, pasta making, cooking without a recipe and much more. There is a strong emphasis on group collaboration and cooperation in this course.',
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
  {
    name: 'Textiles 9',
    department: 'Home Economics',
    grades: [9],
    description: 'This course will cover topics in parts and functions of the sewing machine, fabric terms, construction techniques, measurement, and garment care.  Student projects include a 9-patch pillowcase, string bag or a pair of pyjama shorts.',
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
  {
    name: 'Textiles 10 ',
    department: 'Home Economics',
    grades: [10],
    description: 'This course will cover basic pattern layout, markings and sewing techniques.  Students begin production of their technique portfolio by creating samples of seams, seam finishes and gathering using the sewing machine and serger as well as hand sewing samples.  Students will study fiber and fabric properties as well as the garment industry.  An introduction to the principles and elements of fashion design will help the students understand the design process as they create their projects.  Projects include a hoodie, a creative craft project and a mending assignment.  Higher-level techniques include zipper applications, a project with collar and buttons.',
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
  {
    name: 'Textiles 11 ',
    department: 'Home Economics',
    grades: [11],
    description: 'Students continue production of their technique portfolio by creating samples of seam finishes, hemming, darts and facings using the sewing machine. Topics to be covered include an examination of fiber and fabric properties toward an end use plus the principles and elements of fashion design as well as global awareness of the garment industry and the history of fashion including style and design.  Projects include a housecoat, a creative craft project and a student choice project as long as it includes a dart technique and a waistband. Pattern alterations will be considered with each project as well as flat pattern design.  Flat pattern design will allow for increased student creativity.',
    prerequisites: [{
      req: 'Textiles 10 '
    }],
    video: ''
  },
  {
    name: 'Textiles 12',
    department: 'Home Economics',
    grades: [12],
    description: 'Students continue production of their technique portfolio by creating samples of pocket variations and zipper styles using the sewing machine. Theory topics to be covered include an identification of fiber and fabrics and style and design within the fashion industry as well as labelling and marketing. Projects include a creative craft project and student choice projects that include outerwear, a new pocket technique or a problem fabric.  This course will delve into dart manipulation to increase student creativity.  A prototype half-scale draft pattern will be completed and then made into a final garment Students will have access the 5 thread serger and coverstitch machine to produce professional level garments.',
    prerequisites: [{
      req: 'Textiles 11'
    }],
    video: ''
  },
  {
    name: 'Information Technology 9',
    department: 'Information Technology',
    grades: [9],
    description: 'Build and program a robot, code your own 3D animated story, and design a poster for a movie festival, all with the help of your computer. This course will introduce students to some of the learning opportunities that can be found in the Information Technology elective courses at CHSS.',
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
  {
    name: 'Computer Programming 11 ',
    department: 'Information Technology',
    grades: [10, 11, 12],
    description: 'Ever wondered how computer programs (apps) are written? A basic understanding of coding will help you succeed in countless different career paths. You should take this course if you are thinking of entering a Computer Science or Software Development program at university or college, or if you simply want to learn how to code for fun! You will build your skills as a programmer using Processing, a popular and beginner-friendly language that specializes in graphics. This course is open to students in grades 10 through 12, with decent math skills.',
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
  {
    name: 'Computer Programming 12 ',
    department: 'Information Technology',
    grades: [11, 12],
    description: `Want to take your coding skills even further? This course will allow you to work at your own pace on a series of fun and challenging projects. Customize and add features to classic arcade games re-written in Processing. Write apps that run on Android tablets and smartphones. Play with Microsoft Kinect motion capture cameras. Learn how to create games in Unity. Get hired by a tech startup and become a millionaire!  Okay we can't guarantee that last part...`,
    prerequisites: [{
      req: 'Computer Programming 11'
    }],
    video: ''
  },
    {
    name: 'Woodwork 9 ',
    department: 'Technology',
    grades: [9],
    description: 'Woodwork 9 is a design-build course. Students will learn the principles of design, and create their individual designs based on a given set of criteria. This will include the use of ideation sketches. Students also will learn the use of wood finishes according to the project requirements. These will be teacher-driven projects that will introduce students to the shop and machines. Students will also begin to learn the variety of wood species and their specific uses. Students will also learn the environmental impact of forestation and how to minimize that impact on the environment. Shop and machine safety will be emphasized throughout.',
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
  {
    name: 'Metalwork 10-12',
    department: 'Technology',
    grades: [10, 11, 12],
    description: `Students will learn the following:
    <ul>
    <li>Complex metalworking and design</li>
    <li>Operation and safety of welding equipment</li>
    <li>Casting methods</li>
    <li>Finishing purposes and processes</li>
    <li>Sequence of steps when working with powered and non-powered equipment</li>
    <li>Sheet metal layout, forming, and fabrication</li>
    <li>Heat treatment purposes and processes</li>
    <li>Future career options and opportunities in metalworking contexts</li>
    </ul>`,
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
    {
    name: 'Woodwork 10-12',
    department: 'Technology',
    grades: [10, 11, 12],
    description: 'This course continues the design build program. Students will design projects through the use and creation of plans and drawings. Students will build according to good joinery practices. They will understand identification, characteristics, properties, and uses of wood from various species. Students will learn techniques for stock breakout and woodworking using a variety of tools and equipment, including stationary power equipment including the safety practices for each piece of equipment. They will learn the use and care of handheld tools as appropriate.  There will be one mandatory project and then the student will be free to build a project(s) of their choice and design.',
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
  {
    name: 'Drama 9',
    department: 'Drama',
    grades: [9],
    description: 'Students will be given a basic understanding of the world of theatre while developing performance skills which will help both on stage and in everyday communications.  Mime, choral speaking, improvisation, scene creation, and short script work are the main components of this course.',
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
  {
    name: 'Musical Theatre 9',
    department: 'Drama',
    grades: [9],
    description: 'This course is essentially the production of a major musical.  Students learn the value of developing community, supporting the ensemble, and lifelong confidence in performance skills as they gain knowledge of the basic disciplines of singing, acting and dancing.  Students will audition for this course in the fall.  Priority of casting (this applies to lead roles as well) will go to senior students wherever possible; however, depending on the requirements of the script, it is possible for a Grade 9 or 10 student(s) to earn a lead role.  Rehearsals/classes are held after school hours and there will be three public performances of the entire musical production for the community.  This 4-credit course will end in mid-December or after the final performance, as the necessary hours will have been met by that time. No prior experience is necessary.',
    prerequisites: [{
      req: 'Successful audition'
    }],
    video: 'https://youtu.be/fVaRKDPNzYc',
    tag: 'ott'
  },
  {
    name: 'Drama 10-12',
    department: 'Drama',
    grades: [10, 11, 12],
    description: 'In Drama 10-12 classes, students will create, rehearse, and refine a variety of dramatic works through collaborative and individual presentations or performances. Most presentations will be done in class; however, there is sometimes an opportunity for public performances as well.  In addition, drama students may have the chance to work with student directors on original or published script-work. Drama students will study character development; a variety of genres and cultures; theatre history and contemporary works; the role of the performer, audience, and venue; and dramatic elements such as movement, sound, image, and form. Theatre games and improvisation will also be part of the curriculum as they are an important part of the actor’s development.',
    prerequisites: [{
      req: ''
    }],
    video: 'https://youtu.be/R7SXhBbwe0s'
  },
  {
    name: 'Musical Theatre 10-12',
    department: 'Drama',
    grades: [10, 11, 12],
    description: 'This course is essentially the production of a full-length musical that will be presented three times for the public at the Lester Centre of the Arts. Students will experience the audition, rehearsal, and performance techniques specific to the musical theatre disciplines of drama, music, and dance. They will learn the roles of performer, crew, and audience.  Senior students are expected to mentor younger members of the cast. Musical Theatre classes/rehearsals happen outside of the regular timetable. This 4-credit course will end in mid-December or after the final performance, as the necessary hours will have been met by that time.  No prior experience is necessary.',
    prerequisites: [{
      req: 'Successful audition'
    }],
    video: 'https://youtu.be/fVaRKDPNzYc',
    tag: 'ott'
  },
  {
    name: 'Theatre Production 10-12',
    department: 'Drama',
    grades: [10, 11, 12],
    description: `This is an advanced theatre course for students with some previous experience in backstage or technical theatre, often students who have volunteered for a production(s) in the past. Theatre Production students are the stage managers for the annual musical production. They will work collaboratively with the production team and the performers. Production students will learn about production design, technical theatre, and theatre management as they take on various production roles, attend rehearsals, and work on the set, props and/or costumes for the production. Classes run outside the timetable; this is a 4-credit course.
    <br /><br />
    It is possible for students to take a 2-credit version of Theatre Production in which students are part of the backstage crew and work on the set, props and/or costumes but do not have the stage management responsibilities of attending and supporting all the preliminary rehearsals. This is recommended for inexperienced students and/or grade 9 or 10 students who may be interested in stage-managing in their senior years.`,
    prerequisites: [{
      req: 'Teacher/Director permission'
    }],
    video: 'https://youtu.be/j09X-8Fu4Qg',
    tag: 'ott'
  },
  {
    name: 'Directing and Script Development 11/12',
    department: 'Drama',
    grades: [11, 12],
    description: `Directing and Script Development is an advanced theatre course for students with some experience in theatre.  Students will explore, create, and refine dramatic works.  They will write and direct for an intended audience or with an intended message.  The course will involve play studies to learn the literary techniques, devices and forms as applied to scriptwriting. Students will lead small and large groups to learn the practices related to a variety of directing environments.
    <br /><br />
    Recommended level of entry is 67% (C+) in English, as well as some experience in theatre (e.g., acting classes, musical theatre productions, backstage work.)
    `,
    prerequisites: [{
      req: ''
    }],
    video: 'https://youtu.be/WvH7DEf8lRE'
  },
  {
    name: 'Choral Music 9-12',
    department: 'Music',
    grades: [9, 10, 11, 12],
    description: 'This course is for students who enjoy singing and would like to be part of a vocal ensemble.  Students will be given a variety of music to learn from a wide range of genres and may perform with the band.  Course content will include choral literature, voice production, sight-singing, SATB singing and ear training. Rehearsals and performances for this course will run outside of regular school hours.',
    prerequisites: [{
      req: ''
    }],
    video: 'https://youtu.be/sVLDGc8XG6E',
    tag: 'ott'
  },
  {
    name: 'Instrumental Music 9: Beginner Concert Band ',
    department: 'Music',
    grades: [9],
    description: 'This course provides an opportunity for students to expand on their beginner band experiences and skills at a high school level. Students will continue to master their individual instrument and frame their musical experiences through independent learning, sectionals, as well as group rehearsals. While some instruments are available through the school, most students will be required to provide their own instrument for this course.',
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
  {
    name: 'Jazz Band 9-12',
    department: 'Music',
    grades: [9, 10, 11, 12],
    description: 'This multi-grade ensemble gives the student the opportunity to learn new styles, develop improvisation skills, and learn jazz theory basics. The jazz band is geared toward students who want to challenge their musical knowledge, develop their skills, and have various performance opportunities throughout the year.  It is recommended that students who are interested in taking jazz band are also enrolled in concert band. Rehearsals and performances for this year long course will run outside of regular school hours.',
    prerequisites: [{
      req: ''
    }],
    video: '',
    tag: 'ott'
  },
  {
    name: 'Guitar 9',
    department: 'Music',
    grades: [9],
    description: 'Guitar 9 is an introductory level survey course aimed towards inspiring and exposing students to different types of popular music, musical genres, and musicianship skills before taking Guitar 10-12. This course gives students an opportunity to learn about common guitar chords, techniques, and music fundamentals such as reading tab, and music notation systems on stringed instruments. Students will develop an awareness of popular music through being exposed to multiple genres and artists. Instruments will be provided for students for the duration of this course, however, students may bring their own if desired.',
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
  {
    name: 'Musical Theatre Pit Band 9-12',
    department: 'Music',
    grades: [9, 10, 11, 12],
    description: 'This course is for experienced band students who wish to play in the annual musical production’s orchestra. Students will perform an entire musical score as part of the pit band ensemble, which accompanies the performers on stage. They will learn to express meaning, intent, and emotion through music as well as techniques unique to the musical theatre experience, such as underscoring dialogue.',
    prerequisites: [{
      req: 'Music Director’s assessment'
    }],
    video: '',
    tag: 'ott'
  },
  {
    name: 'Guitar 10-12',
    department: 'Music',
    grades: [10, 11, 12],
    description: 'This course is open to students of all grades and skill levels. The course will give students the opportunity to learn common guitar chords, simple techniques, chord changes, and the ability to read tab, as well as other music notation. Beginner, intermediate, and advanced students will have the opportunity to use this class for further development of their skills and instrumental technique of the Guitar, or Bass. Instruments can be provided to students for the duration of this course, however, students may bring their own if desired.',
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
  {
    name: 'Instrumental Music 10-12: Concert Band',
    department: 'Music',
    grades: [10, 11, 12],
    description: 'Concepts such as articulation, embouchure, blend, balance, tone, and style are introduced to form a foundation of musical awareness that encourages expression, reflection, and performance. It is recommended that students enrolling in this course should have some prior concert band experience and fundamental music skills on a concert band instrument prior to joining. While some instruments are available through the school, most students will be required to provide their own instrument.',
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
  {
    name: 'Music Composition and Production 10-12',
    department: 'Music',
    grades: [10, 11, 12],
    description: 'Music composition and production aims to cultivate music writing skills for different settings, including traditional concert music, electroacoustic music, computer music, film, and game music, as well as popular songwriting. Students will learn to compose for a range of instruments and ensembles, to gain an understanding of music composition, technology, and production techniques. Coursework will center on student-driven creative projects with a performance aspect. All musical styles are encouraged.',
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
  {
    name: 'Art 9',
    department: 'Visual Arts',
    grades: [9],
    description: 'Students will have the opportunity to survey a variety of mediums, learn some basic principles and elements of design.  They will spend time drawing, painting, working in clay and printmaking. Students will then be prepared for larger interest-driven projects in years to come.',
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
  {
    name: 'Art Studio 10-12',
    department: 'Visual Arts',
    grades: [10, 11, 12],
    description: 'The goal of Art Studio courses is to give you a foundation in art.  Students will build on sequential learning experiences that encompass art history, art criticism, aesthetics and production and lead to the creation of quality works.  Students explore traditional and contemporary First People worldviews, stories and art history; analyze, interpret and make informed judgements about artwork and the nature of art; create two-dimensional and three-dimensional works of art using the elements and principles of design, and a range of materials, processes, and technologies.',
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
 {
    name: 'First Nations Art 10-12',
    department: 'Visual Arts',
    grades: [10, 11, 12],
    description: 'This course will focus on key design elements and visual literacy used in Northwest Coast Art, with a heavy emphasis on drawing.  Students will have the opportunity to explore artwork created by First Nations peoples of and around this area (past and present) while learning to respect and adhere to relevant Ts’msyen Protocols.<br /><br /> There is limited space in this course.  Preference will be given to grade 12 students.',
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
  {
    name: 'Photography 10-12',
    department: 'Visual Arts',
    grades: [10, 11, 12],
    description: `Do you have a passion for taking photographs?  Have you ever wondered how to make your photographs more dynamic and interesting?  Then this course is for you!  Students new to photography are introduced to the fundamentals of photography including how to shoot and produce 35mm black and white film.  Students will learn the essentials of how to use a camera, and then how to manage, edit and print their digital images using Photoshop. Students will learn how to use professional studio equipment as well as how to design a basic studio with household items. Students will improve their shooting, and become stronger creatively by learning about some composition essentials and the history of photography. Everything is designed to be accomplished while in class, however many students opt to take photographs outside of class time based on their project themes. Students will ultimately produce a portfolio of work to display their learning.
    <br /><br />
    Students are welcome to take Photography 10, 11 and 12.  Many of the projects change each year.  However, if there is repetition, senior photography students design their independent projects with the teacher to enhance their skills.
    <br /><br />
    Note: If you do not have a camera, the program has both film and digital cameras students can sign out for use!`,
    prerequisites: [{
      req: ''
    }],
    video: 'https://youtu.be/tAE-skCkcFI'
  },
  {
    name: 'Specialized Art Courses',
    department: 'Visual Arts',
    grades: [12],
    description: `<b>Graphic Arts 12</b>
    <br />
    The goal of this course is to develop fundamental skills and understanding of printmaking techniques. Students will apply media, techniques, and process with sufficient skill to communicate intended meaning.  They will create abstract and realistic prints using a variety processes and materials.  Students reflect upon and refine their work; explore cultural and historical connections, and make informed judgements about artwork and the nature of art.
    <br /><br />
    <b>Studio Arts 2D 12</b>
    <br />
    The goal of this course is to understand the fundamental principles of drawing and painting and gain confidence to use them in the pursuit of creating visual art.  Students will be able to demonstrate competency by understanding and executing the elements and principles of design.  Students will focus on the creation of line variation and begin to develop their own mark through various methods and techniques using a variety of materials, processes, and technologies.  Students will begin to understand the history of drawing and painting and its impact on society.  Students will also be able to critique their own work, as well as the work of their peers.
    <br /><br />
    <b>Studio Arts 3D 12</b>
    <br />
    The goal of this course is to develop fundamental skills and understanding of sculpture.  Using materials such as plaster, clay, paper, wire and wood students create quality works.  Students in this course demonstrate a sincere desire to explore a variety of ideas and problems.  They create realistic and abstract sculpture utilizing subtractive and additive processes of modeling, carving, assembling and construction.  They reflect upon and refine their work; explore cultural and historical connections; make informed judgements about artwork and the nature of art.`,
    prerequisites: [{
      req: 'Teacher\'s Permission'
    }],
    video: ''
  },
  {
    name: 'Career Life Education 10',
    department: 'Career Education and Preparation',
    grades: [10],
    description: 'In this course students will be working with these Big Ideas in relationship to Career Life Education: Career-life choices are made in a recurring cycle of planning, reflecting, adapting, and deciding; and Career-life decisions are influenced by internal and external factors, including local and global trends. Financial literacy, mock interviews, overall health, and resumes will also be explored. Students will begin to brainstorm ideas for their Capstone Project which they will present in their grade 12 year. ',
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
  {
    name: 'Peer Tutoring 11/12 ',
    department: 'Career Education and Preparation',
    grades: [10, 11, 12],
    description: 'The Peer Tutoring course fosters social responsibility and develops a student’s personal, intellectual and academic growth.  Students will better understand how people learn and make decisions, and a significant focus is on interpersonal skill development.  Peer tutors assist students and the teacher within the class where they have been placed according to their abilities and interests.  Students considering these courses will act as role models.  They should be dependable, have a genuine interest to help, and maintain excellent attendance.',
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
  {
    name: 'Career Life Connections 12',
    department: 'Career Education and Preparation',
    grades: [12],
    description: 'Career Life Connections 12 students will work with these Big Ideas: Career-life development includes ongoing cycles of exploring, planning, reflecting, adapting, and deciding; Career-life development includes ongoing cycles of exploring, planning, reflecting, adapting, and deciding; engaging in networks and reciprocal relationships can guide and broaden career-life awareness and options; a sense of purpose and career-life balance support well-being; and lifelong learning and active citizenship foster career-life opportunities for people and communities. Students will work to be actively engaged in their capstone by accumulating experiences (in and out of school) related to their Capstone Project. Students will then present their project as a requirement.',
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
  {
    name: 'Work Experience 12A & 12B',
    department: 'Career Education and Preparation',
    grades: [12],
    description: `The Work Experience 12 courses provide students with the opportunity to experience a variety of work placements and occupations of their choosing.  By completing 100 to 120 hours of on-site work throughout the term, students will be able to confirm whether certain occupations are right for them.  Students do not meet regularly in a classroom, as these courses convene each day for students somewhere in the community.
    <br /><br />
    So, why take these courses?  You can test your future, perhaps get part-time work, increase your satisfaction with work, and do better in school.  Research shows that work experience 12 students generally do better in their studies (Ministry of Education, 1993).  There are no exams and no papers, just you working in a variety of jobs to get a glimpse of your future.  There is required paperwork done before, during, and after your work placement.
    <br /><br />
    See Miss Enns in the District Careers Office (Room 311) for more information.`,
    prerequisites: [{
      req: 'Excellent attendance & work ethic'
    }],
    video: ''
  },
  {
    name: 'Youth TRAIN in Trades',
    department: 'Career Education and Preparation',
    grades: [11, 12],
    description: `The Youth TRAIN in Trades program offers apprenticeship training in specific trades at Coast Mountain College while the students continue to be enrolled in high school.  These entry-level trades training programs prepare students for employment and an eventual apprenticeship.  Eligible students attend Coast Mountain College full-time, but must complete their core high school courses either before or after taking their trades program.  Program tuition is paid by the School District and Skilled Trades BC, but students are responsible for all other costs, e.g., tools, books, school supplies, calculator, PPE (Personal Protective Equipment), transportation, and living expenses.  Please note that the Grade 13 opportunity is no longer available.
    <br /><br />
    Secondary school graduation eligibility is maintained as Youth TRAIN in Trades enrollment provides credits toward the Secondary School Dogwood diploma upon completion (70% or better in both the technical course work and the final written examination is required).  How many credits a student can earn depends on the program they choose as different trades have different length programs.
    <br /><br />
    General Qualifications:
    <ul>
    <li>Have parent/guardian permission,
    <li>Completed 60 credits at the time of application,
    <li>Passing Grade 11 courses with a C+ average or better,
    <li>Will pass English 11 with a final mark of C (60%) or better,
    <li>Will pass any Math 11 with a final mark of C (60%) or better,
    <li>Have an excellent attendance record,
    <li>Completed the application package as directed, and
    <li>Attended an interview.
    <li>Note: Construction or Industrial Electrical Foundations also requires Physics 11 and a minimum of Foundations of Mathematics 11 (Pre-Calculus 11 or higher is preferred).
    </ul>
    <br />
    Coast Mountain College Youth TRAIN in Trades Programs Include:
    <ul>
    <li>Automotive Service Technician Foundations,
    <li>Carpentry Foundations,
    <li>Electrical Foundations,
    <li>Hairstylist Foundations,
    <li>Heavy Mechanical Foundations,
    <li>Millwright Foundations, and
    <li>Welding Foundations
    </ul>
    <br />
    See Miss Enns in the District Careers Office (Room 311) for more information and an application package.
    <br /><br />
    Please note that the Youth TRAIN in Trades college programs are adult programs, not secondary school programs.  The majority of the students in these college programs will be adults, with only one or two secondary school students.  The secondary students are expected to function as college students.  The passing mark for these college programs is 70%`,
    prerequisites: [{
      req: ''
    }],
    video: 'https://youtube.com/playlist?list=PLuD9QIA1OMTKUuFptH5bxu5zh14LcIkvX'
  },
  {
    name: 'Youth WORK in Trades',
    department: 'Career Education and Preparation',
    grades: [11, 12],
    description: `This program allows students to access the Provincial Apprenticeship system while still in high school.  For every 120 hours worked with a qualified journeyperson (Red Seal) in a local trade, an evaluation by the journeyperson, and one written assignment, students earn 4 credits towards their Secondary School Dogwood diploma.  There are 4 possible courses (TRN 11A, 11B, 12A, and 12B), so there is a maximum of 16 possible credits.
    <br /><br />
    Qualifications:
    <ul>
    <li>Have parent/guardian permission,
    <li>15 years of age or older,
    <li>Enrolled in Grade 10, 11, or 12,
    <li>Have paid work in an apprenticeable trade,
    <li>Have a qualified journeyperson as a sponsor, and
    <li>Able to provide your own transportation.
    </ul>
    <br />
    If you are working part-time with a local journeyperson, you may be able to start an apprenticeship and continue to work part-time after school, on weekends, or during the summer.  This allows to you to earn (money, apprenticeship hours, and high school credits) while you learn.  Youth WORK in Trades gets you a head start on your career while you are still in high school.
    <br /><br />
    Students enrolled in this program have the opportunity to earn the Youth WORK in Trades $1,000 Award.
    <br /><br />
    See Miss Enns in the District Careers Office (Room 311) for more information.
    <br /><br />
    Parents/guardians, if you are a qualified journeyperson, or are employed by one, and are interested in this program, please contact Susan Enns at 250-624-5031 or Susan.Enns@sd52.bc.ca.`,
    prerequisites: [{
      req: ''
    }],
    video: 'https://youtube.com/playlist?list=PLuD9QIA1OMTJUxXIWYPg3lCt8VwChHkAg'
  },
  {
    name: 'Early Childhood Education',
    department: 'Career Education and Preparation',
    grades: [11, 12],
    description: `ECE is a course taught through Coast Mountain College where students can earn high school and college credits.  This course is comprised of two core classes in the ECE program: ECEE 104 and ECEE 167.
    <br /><br />
    <b>ECCE 104 Health Safety, and Nutrition:</b>
    <br />
    This course covers basic principles and practices as they apply to adults and young children including infants and toddlers. It focuses on health promotion and injury prevention. The content includes healthy eating and the Division of Responsibility, recognizing communicable disease, abuse and neglect, emergency preparedness, assessing environments for health and safety. It also includes reflection on personal health and nutritional status and habits.
    <br /><br />
    <b>ECCE 167 Guiding Young Children:</b>
    <br />
    This course provides the essential components for establishing positive relationships with young children based on teaching, facilitating, and supporting prosocial behaviour. Theory and practical application of alternative approaches to establish emotionally safe and nurturing spaces and genuine, trusting relationships with children and other adults.`,
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
  {
    name: 'Introduction to Health Careers',
    department: 'Career Education and Preparation',
    grades: [11, 12],
    description: `HLTH 101 is a course taught through Coast Mountain College where students can earn high school and college credits.  This course will earn students university credits at the following post-secondary institutions: AU, CAPU, SFU, TRU, UBCO, UVIC, and VIU.
    <br /><br />
    This course provides an overview of health and health care delivery in Canada as well as various health careers available in Canada today for the beginning student. The course also examines the various laws pertaining to health careers such as the Canada Health Act and Health Professions Act as well as ethics in healthcare. Students will have the opportunity to explore the educational paths necessary to gain entry into the various health careers. Students will also have the opportunity to develop awareness of the skills necessary for entry into the health professions, as well as gain insight into their own desired path through self-discovery and self-reflection.
    <br /><br />
    This course will involve 45 hours of Lecture, discussion, guest speakers, and agency visits (depending on availability).`,
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
  {
    name: 'Basketball Academy 9-12',
    department: 'Physical & Health Education',
    grades: [9, 10, 11, 12],
    description: `This course comprises a sport-specific program designed to enable student-athletes to pursue personal excellence in the sport of basketball.  This program is available for students in grades 9, 10, 11 and 12.  It will address the athletic and cognitive needs of students interested in learning about the sport of Basketball.  Training, under the supervision of a qualified teacher-coach, provides students with an outstanding opportunity for accelerated technical development as well as "upper level" cognitive understanding of concepts pertinent to the game.  Basketball promotes physical activity, supports health-related learning, provides leadership opportunities within our community, and enhances students' physical and emotional well-being.`,
    prerequisites: [{
      req: ''
    }],
    video: 'https://youtu.be/35tWcnMiaII'
  },
  {
    name: 'Physical and Health Education 9 and 10',
    department: 'Physical & Health Education',
    grades: [9, 10],
    description: 'This course equips students with the knowledge and skills they need to make healthy choices now and lead healthy, active lives in the future. Through participation in a wide range of physical activities, students develop knowledge and skills related to movement competence and personal fitness that provide a foundation for active living. Students also acquire an understanding of the factors and skills that contribute to healthy development and learn how their well-being is affected by, and affects, the world around them. Students build their sense of self, learn to interact positively with others, and develop their ability to think critically and creatively. Activities during P.E. may include fitness, volleyball, basketball, badminton, softball, soccer, football, minor (lead-up) games, etc.',
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
  {
    name: 'Girl’s Active Living 10-12',
    department: 'Physical & Health Education',
    grades: [10, 11, 12],
    description: 'Girl’s Active Living was created as an alternative to the regular co-ed PE program. This course addresses the specific needs and interests of females in physical activity and health. It is designed to develop activities that provide knowledge and promote life-long health and fitness. Students enrolled in Girls’ Active Living will have a choice on how to meet the learning outcomes of the course. Typical activities include yoga, pilates, core workouts, badminton, teambuilding, minor games, aerobics, dance and many others. This course is open to girls in grades 10, 11, and 12.',
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
  {
    name: 'Active Living 11/12',
    department: 'Physical & Health Education',
    grades: [11, 12],
    description: 'Students enrolled in Active Living will have several opportunities to meet the learning outcomes of the course. The typical sports such as volleyball, badminton, soccer, basketball, and football will be enjoyed as well as activities that include HIIT circuits, weightlifting, cross country running, anatomy, and nutrition. During the term, students will have many opportunities for leadership development through development of their own unit sports. Exploration of recreational facilities that promote activity in the community will also be pursued. ',
    prerequisites: [{
      req: ''
    }],
    video: 'https://youtu.be/gwqhI73YIDk'
  },
  {
    name: 'Fitness and Conditioning 11/12',
    department: 'Physical & Health Education',
    grades: [11, 12],
    description: 'Fitness & Conditioning 11/12 is a course that will focus on supporting and encouraging students to follow a healthy, active lifestyle path.  Individual students will design and implement their training plans and are expected to monitor and assess the effectiveness of their plans in relation to personal goals.  Students will explore current trends and research in fitness including strength training, core training and flexibility, CrossFit, and sport-specific training.  Basic anatomy and physiology will be covered, and proper technique and safety will be emphasized.',
    prerequisites: [{
      req: ''
    }],
    video: 'https://youtu.be/EjBshqw17Gw'
  },
  {
    name: 'French 9',
    department: 'Second Languages',
    grades: [9],
    description: 'In French 9, emphasis is put on verbal communication.  Topics include: Communication in the future and past tenses about music, cinema, celebrations and friendship, publicity, communication, family, and environment.',
    prerequisites: [{
      req: `French 8 or Teacher's permission`
    }],
    video: ''
  },
  {
    name: 'French 10',
    department: 'Second Languages',
    grades: [10],
    description: 'Now that you’ve mastered some basic skills in French, enhance your linguistic journey by continuing on in French 10.  Often called the most creative year in core French studies at CHSS, French 10 takes you on a voyage through fairy tale lands, French cuisine, embarrassing body ailments, and how annoying your siblings can be around the house.  Explore your hopes and dreams as you plan your future career opportunities.  Step into the shoes of Van Gogh and create a masterpiece in his artistic style.  Have fun, and expand your fluency!',
    prerequisites: [{
      req: `French 9 or Teacher's permission`
    }],
    video: ''
  },
  {
    name: 'French 11',
    department: 'Second Languages',
    grades: [11],
    description: 'French 11 offers students an immersive experience in the French language and Francophone culture. Designed to build upon foundational skills developed in earlier grades, this course emphasizes communication, comprehension, and cultural appreciation. Students engage in a variety of activities, including speaking, listening, reading, and writing exercises, to enhance their fluency and proficiency in French. Through authentic materials and interactive lessons, learners explore themes relevant to their lives while expanding their knowledge of French-speaking communities around the world. Overall, French 11 aims to empower students to communicate effectively in French and to develop a deeper understanding and appreciation of the Francophone world.',
    prerequisites: [{
      req: `French 10 or Teacher's permission`
    }],
    video: ''
  },
  {
    name: 'French 12',
    department: 'Second Languages',
    grades: [12],
    description: 'French 12 is an enriching continuation of the French language journey. The course offers students an exciting opportunity to further refine their linguistic skills and deepen their cultural understanding. Building upon the foundation laid in previous years, this course delves into more complex language structures, advanced vocabulary, and nuanced cultural topics. Through engaging activities, authentic resources, and interactive projects, students not only enhance their fluency in French but also develop critical thinking skills and cross-cultural competence. Often this course is combined with French 11 to be taught simultaneously.',
    prerequisites: [{
      req: `French 11 or Teacher's permission`
    }],
    video: ''
  },
  {
    name: 'Sm’algyax 9',
    department: 'Second Languages',
    grades: [9],
    description: 'This course will build upon the grade 8 Sm’algyax course.  Students will add to their knowledge of the structure of Sm’algyax as they practice using the language in simulated everyday life situations.  Listening and speaking skills will continue to be the primary focus with increased emphasis on writing and reading Sm’algyax.',
    prerequisites: [{
      req: 'Sm’algyax 8'
    }],
    video: ''
  },
  {
    name: 'Sm’algyax 10',
    department: 'Second Languages',
    grades: [10],
    description: 'This course will build upon the structural aspect of the language, enhancing students’ understanding of grammar and use of everyday language.  Students will be introduced to the present tense, demonstrating their understanding through the creation of short stories.  Students will engage in total physical response, furthering their abilities to listen and give commands in Sm’algyax.  Students will be evaluated on their story project, weekly assignments, exams and participation.',
    prerequisites: [{
      req: 'Sm’algyax 9'
    }],
    video: ''
  },
  {
    name: 'Sm’algyax 11/12',
    department: 'Second Languages',
    grades: [11, 12],
    description: `This course will be a continuation of Sm’algyax 10 with an emphasis on verbal communication, while also developing students’ abilities to listen, read and write in Sm’algyax.  This will be achieved through the study and retelling of our Ts’msyen Adaawx.  Students will present visual and written projects while providing the narration in Sm’algyax.  Students will also further advance their grammar and use of everyday language, learning to create sentences using the future and past tenses.  Students will be evaluated on their Adaawx retelling, weekly assignments, exams and participation.
    <br /><br />
    Recommended level of entry is 67% (C+) in Sm’algyax 10.`,
    prerequisites: [{
      req: 'Sm’algyax 10'
    }],
    video: ''
  },
  {
    name: 'Social Studies 9',
    department: 'Social Studies',
    grades: [9],
    description: `Social Studies 9 examines the 1700 and 1800s. During this time, European countries explored and colonized the rest of the world.  Today’s world is greatly affected by the actions and beliefs of early modern Europeans who arrived in the ‘new world’ during this period and their encountered indigenous peoples who were already there. These countries' current strengths and weaknesses are largely the result of relationships built during these 200 years. Understanding this era helps us understand who we are as citizens of this world, and who we want to be as advocators for a better future.
  `,
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
  {
    name: 'Social Studies 10',
    department: 'Social Studies',
    grades: [10],
    description: 'Socials Studies 10 examines Canada and the world from 1900 to today. With Canada’s greater participation in world affairs, including the two World Wars, Canada’s new identity is examined. There will be a focus on how global and regional conflicts have been a powerful force in shaping our contemporary world. The course will also examine Canada’s role as a peacekeeper in the world, Canada’s changing economy and the need to face challenges in a changing world will be explored. There will be a focus on how historical and contemporary injustices challenge the narrative and identity of Canada as an inclusive, multicultural society. A special focus will be put on the impact of colonialism, including residential schools, on indigenous people.  Finally, Canada’s political institutions, demography, the environment and how humans are changing the planet will be examined in Social Studies 10.',
    prerequisites: [{
      req: ''
    }],
    video: 'https://youtu.be/16RYtmzIhkg'
  },
  {
    name: '20th Century History 12',
    department: 'Social Studies',
    grades: [11, 12],
    description: 'History 12 deals with world history from 1919 to the end of the 20th century. Students will develop their research, critical thinking, reading and writing skills as related to the study of history. Students will first examine World War I, the Russian revolution, nationalism, imperialism, political ideologies and World War II. In the second half of the course from the end of World War II to today topics to be studied will include the Cold War, the Middle East, China, and human rights.',
    prerequisites: [{
        req: 'Social Studies 10'
      },
      {
        req: 'any English 10'
      }
    ],
    video: 'https://youtu.be/z7XGLzRgqJ4'
  },
  {
    name: 'B.C. First Peoples 12',
    department: 'Social Studies',
    grades: [11, 12],
    description: 'B.C. First Peoples 12 studies the Indigenous Peoples of British Columbia, with emphasis placed on local Indigenous nations and territories.  Students will gain an understanding of First Peoples’ culture before and after contact with Europeans.  The first part of this course explores the complex and sophisticated social and political Indigenous structures before European contact, and relies heavily on sacred stories and information shared by Elders, other role models, and histories vetted by our Aboriginal Education department.  The history of the post-contact era, covered in the second part, will focus on the history of European-Indigenous relationships since first contact, as well as colonial attitudes and practices and Indigenous resistance to these practices and attitudes. Movements of resistance such as land claims, Idle No More, MMIWG, Indigenous Environmental Network and other expressions of self-determination will be examined. How Indigenous people are currently expressing their rights to language, custom and tradition, land sovereignty, and self-governance will also be discussed in addition to the resurgence in First Peoples art and culture in painting, carving, weaving, singing, drumming, dancing and graphic novels.',
    prerequisites: [{
        req: 'Social Studies 10'
      },
      {
        req: 'any English 10'
      }
    ],
    video: 'https://youtu.be/Q4Aj8xYo2m8'
  },
  {
    name: 'Social Justice 12',
    department: 'Social Studies',
    grades: [11, 12],
    description: 'The course looks at a number of topics; from government policy, feminism, Indigenous rights, climate change, LGBTQ+ issues and more. Students are encouraged to think critically and evaluate many viewpoints pertaining to each discussed topic to reach their own conclusions regarding their own beliefs about what it means to be a socially justice human in this world. Social Justice is a course that is more than just words, it is action. It is meant to challenge one’s perception of the world, so that we can become more empathic towards others and understand that the world is not created equal, but equity can be fought for.',
    prerequisites: [{
        req: 'Social Studies 10'
      },
      {
        req: 'any English 10'
      }
    ],
    video: 'https://youtu.be/PD3s9MAXDzA'
  },
  {
    name: 'Français Langue Seconde-Immersion 9/10',
    department: 'Français Langue Seconde-Immersion',
    grades: [9, 10],
    description: `Familiers avec les notions de grammaire déjà apprises, les participants de ce cours ont l’occasion de les appliquer dans leur production écrite et de les utiliser en classe lors des débats et aussi dans leur élocution quotidienne. Ils peuvent lire et interpréter des morceaux choisis selon leur niveau et s’intégrèrent aussi dans la culture francophone. Tout au long de ce cours, les étudiants participent à des activités de communication orale, de lecture et d'écriture tout en étudiant diverses œuvres, notamment des romans, des textes d’actualité courante, provenant de régions francophones d'Amérique du Nord. `,
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
  {
    name: 'Sciences 9/10',
    department: 'Français Langue Seconde-Immersion',
    grades: [9, 10],
    description: `Science 9 permet aux étudiants de développer des concepts de base en chimie, biologie, physique et durabilité environnementale; développer des compétences dans le processus de recherche scientifique; et à la science liée à la technologie, à la société et à l'environnement. Les étudiants travaillent en mettant l'accent sur la nature de la science (compétences scientifiques et sécurité en laboratoire). Science 10 s'appuie sur les concepts abordés en Science 9 et il favorise l'engagement des étudiants avec des concepts scientifiques clés et à continuer à développer des compétences de pensée critique. Les sujets couverts incluent : la sécurité en laboratoire et la méthode scientifique ; produits et réactions chimiques; énergie et radioactivité ; ADN et génétique; et l'astronomie et la théorie du Big Bang. `,
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
  {
    name: 'Sciences Humaines 9/10',
    department: 'Français Langue Seconde-Immersion',
    grades: [9, 10],
    description: `Ce cours relate l’histoire du Canada depuis avant l’arrivée des Colons jusqu’à l’époque contemporaine où les événements actuels sont aussi à l’étude. Il offre aussi un regard sur les actions et croyances des premiers Européens modernes qui sont arrivés dans le « Nouveau Monde » et aussi leur interaction avec les peuples autochtones qui s'y trouvaient déjà. On examine aussi la création du Canada, sa présence sur le plan international après les deux guerres mondiales et son apparition en tant que gardien de la paix dans le monde. Les institutions politiques du Canada, la démographie, l'environnement et la façon dont les humains changent la planète en sont aussi examinés. `,
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
  {
    name: 'Communication Orale 11',
    department: 'Français Langue Seconde-Immersion',
    grades: [11, 12],
    description: `Surtout axé sur la production langagière et aussi sur la compréhension orale, le cours de communication orale permet aux élèves de développer un sentiment d’appartenance à la culture francophone. En plus d’être à l’écoute des médias francophones, ils ont l’opportunité d’apporter leur point de vue lors des débats et discussions en classe et dont les thèmes ont été choisis dans l’actualité courante et en mettant l'emphase aussi sur les points de grammaire déjà acquis. Ce cours permet à l’élève d’analyser divers types de médias pour mieux comprendre leur rôle et leur influence dans la société. En réalisant des présentations et débats en classe, l’élève acquiert des connaissances et des habiletés qui favorisent le développement de son sens critique. `,
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
  {
    name: 'Exploration en Sciences Humaines et Sociales 11',
    department: 'Français Langue Seconde-Immersion',
    grades: [11, 12],
    description: `Ce cours traite de l'histoire du droit et des questions éthiques, sociales et juridiques liées aux droits civils, aux droits de la Charte et aux droits de la personne. Les questions juridiques et sociales actuelles sont également abordées. Le droit pénal se concentre sur le crime, les enquêtes criminelles, les affaires judiciaires et les procès et aussi des études de cas. Les rapports écrits, les discussions en classe, les activités de groupe font également partie du cours.`,
    prerequisites: [{
      req: ''
    }],
    video: ''
  },
  {
    name: 'Français Langue Seconde-Immersion 12',
    department: 'Français Langue Seconde-Immersion',
    grades: [12],
    description: `L’utilisation du Français de façon usuelle n’a presque plus de secrets pour eux, car ils peuvent facilement dialoguer, exposer leur point de vue et disséquer aisément textes et nouvelles écrits et/ou oraux. Présentations, débats sur de variés sujets et échanges entre camarades en Français en classe sont fortement encouragés et appuyées par des activités éducatives conçues pour la promotion du Français au quotidien. À l’oral, l’accent est mis sur l’interprétation de récits médiatiques courants; en lecture et en écriture, l’élève interprète et produit des textes utilitaires se rapportant au monde du travail et à la vie de tous les jours. Ce cours permet à l’élève d’approfondir ses connaissances en communication orale, en lecture et en écriture. `,
    prerequisites: [{
      req: ''
    }],
    video: ''
  }
]
